export const numberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const numbersOnly = (string) => {
    let filteredString = string.replace(/[^0-9]/gi, '');
    return filteredString
}

export const numbersWithFourDecimals = (string) => {
    let value = string.match(/^\d+(\.\d{0,4})?/)?.[0] || '';

    // Convert to number and check the limit
    if (parseFloat(value) > 100) {
        return '100';
    }

    return value;
};


export const skeletonArray = (n) => {
    return new Array(n).fill(1)
}

export function isMobileTenDigits(mobile) {
    return (mobile.length == 10)
}


export function validatePhoneNumber(phoneNumber, country) {
  
    let count = 0;
    for (let i = 0; i < country.format.length; i++) {
        if (country.format[i] === '.') {
            count++;
        }
    }

    const validLengths = [11, 12, 13, 14, 15, 16, 17];
    if (validLengths.includes(count)) {
        const isValid = validLengths.includes(phoneNumber.length);
        return isValid;
    }

    return count === phoneNumber.length;

};